import {Component, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "angular2-social-login";
import {Conf} from "../settings/config";
import {FunctionsService} from "../services/functions.service";

@Component({
    selector: 'app-meetings',
    templateUrl: './meetings.component.html'
})
export class MeetingsComponent implements OnInit {

    public slug;
    public page = {
        title: '',
        slug: '',
        cover_image: '',
        banner_text: '',
        content: '<h1>404</h1>'
    };

    blogs = [];

    tours = [];
    tour_operators = [];

    suppliers = [];
    supplier_types = [];

    selected_supplier_types = '';
    selected_tour_operators = '';


    constructor(private route: ActivatedRoute, private http: HttpClient, public _auth: AuthService) {

    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.slug = params['slug'];
            this.getPage(this.slug);
        });
    }

    getPage(slug) {
        this.slug = slug;
        this.http.get(Conf.API_URL + '/bar/?slug=' + this.slug).subscribe(
            data => {
                if (data['results'].length) {
                    this.page = data['results'][0];
                } else {
                    this.page = {
                        title: '',
                        slug: '',
                        cover_image: '',
                        banner_text: '',
                        content: '<h1>404</h1>'
                    }
                }

                if (this.slug == 'team-building-incentives') {
                    this.http.get(Conf.API_URL + '/blog/?page_size=3').subscribe(
                        data => {
                            if (data['results'].length) {
                                this.blogs = data['results'];
                            }
                        },
                        error => {
                            console.log(error.error)
                        }
                    );
                    this.http.get(Conf.API_URL + '/tour/?page_size=3').subscribe(
                        data => {
                            if (data['results'].length) {
                                this.tours = data['results'];
                            }
                        },
                        error => {
                            console.log(error.error)
                        }
                    );
                }

                if (this.slug == 'plan-your-event') {

                    this.http.get(Conf.API_URL + '/supplier-type/?show_all').subscribe(
                        data => {
                            if (data['results'].length) {
                                this.supplier_types = data['results'];
                            }
                        },
                        error => {
                            console.log(error.error)
                        }
                    );
                    this.http.get(Conf.API_URL + '/supplier/?show_all').subscribe(
                        data => {
                            if (data['results'].length) {
                                this.suppliers = data['results'];
                            }
                        },
                        error => {
                            console.log(error.error)
                        }
                    );
                    this.http.get(Conf.API_URL + '/tour/?show_all').subscribe(
                        data => {
                            if (data['results'].length) {
                                this.tours = data['results'];
                            }
                        },
                        error => {
                            console.log(error.error)
                        }
                    );

                    this.http.get(Conf.API_URL + '/tour-operators/?show_all').subscribe(
                        data => {
                            if (data['results'].length) {
                                this.tour_operators = data['results'];
                            }
                        },
                        error => {
                            console.log(error.error)
                        }
                    );
                }

            },
            error => {
                console.log(error.error)
            }
        );
    }

    choseSupplier() {

        this.selected_supplier_types = $('input[name="supplier_type"]:checked').map(function () {
            return $(this).val();
        }).get().join(',');

        this.http.get(Conf.API_URL + '/supplier/?show_all&type=' + this.selected_supplier_types).subscribe(
            data => {
                this.suppliers = data['results'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    choseOperator() {
        this.selected_tour_operators = $('input[name="operator"]:checked').map(function () {
            return $(this).val();
        }).get().join(',');

        this.http.get(Conf.API_URL + '/tour/?show_all&operator=' + this.selected_tour_operators).subscribe(
            data => {
                this.tours = data['results'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    firstParagraph(html) {
        return FunctionsService.firstParagraph(html)
    }

}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/meetings/meetings.component.ts